export default [
	'SITEBUILDER_LINCOLN_BLUECRUISE_1',
	'SITEBUILDER_BLUECRUISE_1',
	'SITEBUILDER_EV_CHARGING_1',
	'SITEBUILDER_FORD_F_150_LIGHTNING_1',
	'SITEBUILDER_2023_FORD_MACH_E_1'
];
